import { render } from "./schoolSafeDetail.vue?vue&type=template&id=98eab222&scoped=true"
import script from "./schoolSafeDetail.vue?vue&type=script&lang=js"
export * from "./schoolSafeDetail.vue?vue&type=script&lang=js"

import "./schoolSafeDetail.vue?vue&type=style&index=0&id=98eab222&scoped=true&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98eab222"]])

export default __exports__